// Supabase project wiring for the Executive Challenge backend.
//
// Both values empty ⇒ the app runs on the Phase 1 local stub, byte-identical
// to pre-backend behavior. Fill both in (see supabase/README.md for project
// setup) and index.ts flips to the real implementation. The anon key is a
// publishable client credential — safety comes from RLS, not from hiding it —
// so committing it here is fine once a real project exists.

// Annotated as string (not the "" literal type) so the selector comparison in
// index.ts stays meaningful to the type checker once values are filled in.
export const SUPABASE_URL: string = "https://qxhmdopnsseuymzdxjuh.supabase.co";

export const SUPABASE_ANON_KEY: string =
	"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InF4aG1kb3Buc3NldXltemR4anVoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODMzODY1MjgsImV4cCI6MjA5ODk2MjUyOH0.Bv3qZrek-vHret7r3_PnQFR4tiAdvzs3d1kNSKz2WXw";

// How entrants get an identity.
//
// "anonymous": no SMS anywhere — the first challenge action mints a Supabase
// anonymous user for the device (enable "Allow anonymous sign-ins" in the
// project's Auth settings). Real sessions, real RLS, real cross-device
// leaderboards; the one-entry-per-person rule is per DEVICE identity, since
// clearing site data mints a new one. The verify sheet skips phone + OTP and
// goes straight to initials.
//
// "phone": the launch configuration — SMS OTP via the project's phone
// provider (Twilio + 10DLC; see supabase/README.md). One entry per verified
// phone, across devices and reinstalls.
export const SUPABASE_AUTH_MODE: "anonymous" | "phone" = "anonymous";
